import loadable from "@loadable/component";

export const AddEditBookForm = loadable(() =>
  import("./EditBookForm/index.form"),
);
